// USAGE EXAMPLE: global_languages_translations[currentLanguageLocale()].quiz.select_text

var currentLanguageLocale = () => {
  //returns curent locale language iso code
  if (Shopify.locale == 'pt-PT') {
    return 'pt'
  }
  else {
    return Shopify.locale
  }
}

var global_languages_translations = {
  en: {
    full_page_pop_up: {
      email_validation: {
        empty_email: "Please add an email.",
        invalid_email: "Sorry, email format is not valid."
      },
      phone_validation: {
        empty_phone: "Please add a phone number.",
        invalid_phone: "Sorry, phone number format is not valid."
      }
    },
    prev_viewed: {
      title: `Previously <strong>viewed</strong>`
    },
    view_more: "view more",
    view_less: "view less",
    get_notified: "get notified",
    email_register_success: "Thanks for Joining!",
    quiz: {
      select_text: "select",
      remove_text: "remove",
      max_products_text: "max products selected",
      error_text: "Sorry, no matches found."
    },
    scent_families: {
      shop_now: "Shop now"
    },
    cart: {
      you_might_like_text: "You might <strong>like to add</strong>"
    },
    product_card: {
      ATC: "ADD TO CART",
      get_notified: "GET NOTIFIED"
    },
    cat: {
      products_number: "products",
      header: {
        title_all: "Shop All",
        title_women: "Women",
        title_men: "Men",
        title_unisex: "Unisex",
        title_sets: "Gift sets",
        title_bestseller: "Bestsellers"
      }
    },
    from_text: "From",
    top_bar: {
      left_promo_text_sign_up: "Sign up for 20% OFF",
      left_promo_text_no_sign_up: "Get 20% OFF!",
      promo_text_v1: `<strong>HOLIDAY SALE:</strong>40% <strong>OFF</strong> <br class='desktop-hidden'> + FREE shipping`,
      promo_text_v2: `<strong>LAST DAYS<\/strong> to order for guaranteed <br class='desktop-hidden'/> Valentine's Day delivery!`,
      promo_text_v3: `<strong>FINAL DAY</strong> to order for guaranteed <br class='desktop-hidden'/> Valentine's Day delivery!`
    },
    bundle_builder: {
      no_results: "No results found for:",
      you_might_like_text: "You might like these:",
      added_text: "ADDED"
    },
    back_to_search_text: "Back to search results",
    search_no_scent_results: "No scent notes found for the term"
  },
  de: {
    full_page_pop_up: {
      email_validation: {
        empty_email: "Bitte fügen Sie eine E-Mail-Adresse hinzu.",
        invalid_email: "Entschuldigung, das E-Mail-Format ist ungültig."
      },
      phone_validation: {
        empty_phone: "Bitte fügen Sie eine Telefonnummer hinzu.",
        invalid_phone: "Entschuldigung, das Format der Telefonnummer ist nicht gültig."
      }
    },
    prev_viewed: {
      title: `Zuvor <strong>angeschaut<\/strong>`
    },
    view_more: "mehr sehen",
    view_less: "weniger anzeigen",
    get_notified: "Benachrichtigt mich",
    email_register_success: "Danke für Ihre Teilnahme!",
    quiz: {
      select_text: "wählen",
      remove_text: "entfernen",
      max_products_text: "Maximale Anzahl Produkte ausgewählt",
      error_text: "Es wurden leider keine Übereinstimmungen gefunden."
    },
    scent_families: {
      shop_now: "Jetzt kaufen"
    },
    cart: {
      you_might_like_text: "Vielleicht möchten Sie <strong>hinzufügen</strong>"
    },
    product_card: {
      ATC: "In den Warenkorb",
      get_notified: "Benachrichtigt mich"
    },
    cat: {
      products_number: "Anzahl der Produkte",
      header: {
        title_all: "Alle einkaufen",
        title_women: "Damen",
        title_men: "Herren",
        title_unisex: "Unisex",
        title_sets: "Geschenksets",
        title_bestseller: "Verkaufsschlager"
      }
    },
    from_text: "Ab",
    top_bar: {
      left_promo_text_sign_up: "Anmelden für bis zu <br> 20% RABATT",
      left_promo_text_no_sign_up: "Bis zu 20% RABATT erhalten!",
      promo_text_v1: `<strong>FEIERTAGS-SALE:</strong> Bis zu <strong>40% RABATT</strong> <br class='desktop-hidden'> + KOSTENLOSER Versand`,
      promo_text_v2: `<strong>LETZTE TAGE:</strong> Bestelle jetzt für eine <br class='mobile-hidden'/> garantierte <br class='desktop-hidden'/> Lieferung vor dem Valentinstag!`,
      promo_text_v3: `<strong>LETZTER TAG:</strong> Bestelle jetzt für eine <br class='mobile-hidden'/> garantierte <br class='desktop-hidden'/> Lieferung vor dem Valentinstag!`,
    },
    bundle_builder: {
      no_results: "Keine Ergebnisse gefunden für:",
      you_might_like_text: "Das könnte Ihnen gefallen:",
      added_text: "hinzugefügt"
    },
    back_to_search_text: "Zurück zur Suche",
    search_no_scent_results: "No se encontraron notas olfativas para el término"
  },
  it: {
    full_page_pop_up: {
      email_validation: {
        empty_email: "Per favore, aggiungi un'email.",
        invalid_email: "Spiacenti, il formato dell'email non è valido."
      },
      phone_validation: {
        empty_phone: "Per favore, aggiungi un numero di telefono.",
        invalid_phone: "Spiacenti, il formato del numero di telefono non è valido."
      }
    },
    prev_viewed: {
      title: `<strong>Visualizzati</strong> in precedenza`
    },
    view_more: "vedi di più",
    view_less: "vedi meno",
    get_notified: "Avvisami",
    email_register_success: "Grazie per l'iscrizione!",
    quiz: {
      select_text: "selezionare",
      remove_text: "eliminare",
      max_products_text: "prodotti massimi selezionati",
      error_text: "Spiacenti, non sono state trovate corrispondenze."
    },
    scent_families: {
      shop_now: "Acquista ora"
    },
    cart: {
      you_might_like_text: "Potresti <strong>voler aggiungere</strong>"
    },
    product_card: {
      ATC: "Aggiungi al carrello",
      get_notified: "Avvisami"
    },
    cat: {
      products_number: "n. prodotti",
      header: {
        title_all: "Vendita intera collezione",
        title_women: "Donna",
        title_men: "Uomo",
        title_unisex: "Unisex",
        title_sets: "Set Regalo",
        title_bestseller: "I più venduti"
      }
    },
    from_text: "Da",
    top_bar: {
      left_promo_text_sign_up: "Iscriviti e ricevi <br/> SCONTI fino al 20%",
      left_promo_text_no_sign_up: "Fino al 20% di sconto!",
      promo_text_v1: `<strong>SALDI NATALIZI:</strong> SCONTI <strong>fino al 40%</strong> <br class='desktop-hidden'> + spedizione GRATUITA`,
      promo_text_v2: `<strong>ULTIMI GIORNI:</strong> ordina ora per la <br class='mobile-hidden'/> consegna <br class='desktop-hidden'/> garantita entro San Valentino!`,
      promo_text_v3: `<strong>ULTIMO GIORNO:</strong> ordina ora per la <br class='mobile-hidden'/> consegna <br class='desktop-hidden'/> garantita entro San Valentino!!`,
    },
    bundle_builder: {
      no_results: "Nessun risultato trovato per:",
      you_might_like_text: "Potrebbero piacerti questi:",
      added_text: "AGGIUNTO"
    },
    back_to_search_text: "Torna alla Ricerca”",
    search_no_scent_results: "Nessuna nota olfattiva trovata per il termine"
  },
  es: {
    full_page_pop_up: {
      email_validation: {
        empty_email: "Por favor, añade un correo electrónico.",
        invalid_email: "Lo siento, el formato del correo electrónico no es válido."
      },
      phone_validation: {
        empty_phone: "Por favor, añade un número de teléfono.",
        invalid_phone: "Lo siento, el formato del número de teléfono no es válido."
      }
    },
    prev_viewed: {
      title: `<strong>Visto anteriormente</strong>`
    },
    view_more: "ver más",
    view_less: "ver MENOS",
    get_notified: "Notificarme",
    email_register_success: "¡Gracias por unirte!",
    quiz: {
      select_text: "seleccionar",
      remove_text: "eliminar",
      max_products_text: "Máximo de productos seleccionados",
      error_text: "Lo sentimos, no se encontraron coincidencias."
    },
    scent_families: {
      shop_now: "Compra ahora."
    },
    cart: {
      you_might_like_text: "Quizás le gustaría agregar"
    },
    product_card: {
      ATC: "Agregar al carrito",
      get_notified: "Notificarme"
    },
    cat: {
      products_number: "n.º de productos",
      header: {
        title_all: "Todo",
        title_women: "Mujeres",
        title_men: "Hombres",
        title_unisex: "Unisex",
        title_sets: "Conjuntos de Regalo",
        title_bestseller: "Mas vendidos"
      }
    },
    from_text: "From",
    top_bar: {
      left_promo_text_sign_up: "Regístrate y consigue <br/> hasta 20% MENOS",
      left_promo_text_no_sign_up: "Obtenga hasta <strong>20% MENOS!<\/strong>",
      promo_text_v1: `<strong>REBAJAS NAVIDEÑAS:</strong> Hasta un <strong>40% MENOS</strong> <br class='desktop-hidden'> + envíos GRATIS`,
      promo_text_v2: `<strong>ÚLTIMOS DÍAS:</strong> ¡Haz un pedido con <br /> entrega garantizada para San Valentín!`,
      promo_text_v3: `<strong>ÚLTIMO DÍA:</strong> ¡Haz un pedido con <br /> entrega garantizada para San Valentín!`,
    },
    bundle_builder: {
      no_results: "No se encontraron resultados para:",
      you_might_like_text: "Te podrían gustar estos:",
      added_text: "AÑADIDO"
    },
    back_to_search_text: "Volver a la Búsqueda",
    search_no_scent_results: "No se encontraron notas olfativas para el término"
  },
  pt: {
    full_page_pop_up: {
      email_validation: {
        empty_email: "Por favor, adicione um e-mail.",
        invalid_email: "Desculpe, o formato do e-mail não é válido."
      },
      phone_validation: {
        empty_phone: "Por favor, adicione um número de telefone.",
        invalid_phone: "Desculpe, o formato do número de telefone não é válido."
      }
    },
    prev_viewed: {
      title: `<strong>Vistos previamente</strong>`
    },
    view_more: "ver mais",
    view_less: "ver MENOS",
    get_notified: "Receba Notificações",
    email_register_success: "Obrigado por participar!",
    quiz: {
      select_text: "selecionar",
      remove_text: "remover",
      max_products_text: "produtos máximos selecionados",
      error_text: "Desculpe, não foi encontrado qualquer partida."
    },
    scent_families: {
      shop_now: "Loja agora"
    },
    cart: {
      you_might_like_text: "Pode <strong> gostar de adicionar</strong>"
    },
    product_card: {
      ATC: "Adicionar ao carrinho",
      get_notified: "Receba Notificações"
    },
    cat: {
      products_number: "n.º de produtos",
      header: {
        title_all: "Ver Todos",
        title_women: "Feminino",
        title_men: "Masculino",
        title_unisex: "Unissex",
        title_sets: "Conjuntos de Presente",
        title_bestseller: "Mais Vendidos"
      }
    },
    from_text: "A partir de",
    top_bar: {
      left_promo_text_sign_up: "Registe-se para  até <br class='desktop-hidden'> 20% de DESCONTO",
      left_promo_text_no_sign_up: "Ganhe 20% OFF!",
      promo_text_v1: `<strong>PROMOÇÃO DE BOAS FESTAS:</strong> Até <strong>40% de <br class='desktop-hidden'> DESCONTO</strong>  + envio GRATUITO`,
      promo_text_v2: `<strong>ÚLTIMOS DIAS:</strong> peça agora e receba <br class='mobile-hidden'/> até o Dia dos Namorados!`,
      promo_text_v3: `<strong>ÚLTIMO DIA:</strong> peça agora e receba <br class='mobile-hidden'/> até o Dia dos Namorados!`,
    },
    bundle_builder: {
      no_results: "Nenhum resultado encontrado para:",
      you_might_like_text: "Pode gostar destes:",
      added_text: "ADICIONADO"
    },
    back_to_search_text: "Voltar à Pesquisa",
    search_no_scent_results: "Nenhuma nota olfativa encontrada para o termo"
  },
  fr: {
    full_page_pop_up: {
      email_validation: {
        empty_email: "Veuillez ajouter une adresse e-mail.",
        invalid_email: "Désolé, le format de l'e-mail n'est pas valide."
      },
      phone_validation: {
        empty_phone: "Veuillez ajouter un numéro de téléphone.",
        invalid_phone: "Désolé, le format du numéro de téléphone n'est pas valide."
      }
    },
    prev_viewed: {
      title: `Previously <strong>viewed</strong>`
    },
    view_more: "view more",
    view_less: "view less",
    get_notified: "ENVOYER",
    email_register_success: "Thanks for Joining!",
    quiz: {
      select_text: "select",
      remove_text: "remove",
      max_products_text: "max products selected",
      error_text: "Sorry, no matches found."
    },
    scent_families: {
      shop_now: "Shop now"
    },
    cart: {
      you_might_like_text: "Vous voudrez peut-être ajouter"
    },
    product_card: {
      ATC: "AJOUTER AU PANIER",
      get_notified: "SOYEZ INFORMÉ"
    },
    cat: {
      products_number: "products",
      header: {
        title_all: "Shop All",
        title_women: "Women",
        title_men: "Men",
        title_unisex: "Unisex",
        title_sets: "Gift sets",
        title_bestseller: "Bestsellers"
      }
    },
    from_text: "From",
    top_bar: {
      left_promo_text_sign_up: "Sign up for 20% OFF",
      left_promo_text_no_sign_up: "Get 20% OFF!",
      promo_text_v1: `<strong>HOLIDAY SALE:</strong>40% <strong>OFF</strong> <br class='desktop-hidden'> + FREE shipping`,
      promo_text_v2: `<strong>DERNIERS JOURS :</strong> Commandez pour une <br class='mobile-hidden'/> livraison garantie pour la St-Valentin! `,
      promo_text_v3: `<strong>DERNIER JOUR :</strong> Commandez pour une <br class='mobile-hidden'/> livraison garantie  pour la St-Valentin! `
    },
    bundle_builder: {
      no_results: "Aucun résultat trouvé pou:",
      you_might_like_text: "Vous pourriez aimer ceux-ci:",
      added_text: "AJOUTÉ"
    },
    back_to_search_text: "Retour à la recherche",
    search_no_scent_results: "Aucune note olfactive trouvée pour le terme"
  },
}